<template>
    <modal @close="closeModal" dialog="modal-lg" class="dark-top" :footer="false" :header="false">
        <div slot="body">
            <div class="p-4">
                <h2 class="mb-4 text-center bold">Learn more about Group Prices</h2>

                <table class="table">
                    <thead>
                        <tr>
                            <th v-for="(data, i) in tableData.titles"
                                :key="`title-${i}`"
                                :width="data.width"
                            >
                                {{ data.title }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, j) in tableData.rows"
                            :key="`row-${j}`"
                        >
                            <td>{{ row.priceType }}</td>
                            <td>{{ row.description }}</td>
                            <td>{{ row.channelCompatibility }}</td>
                        </tr>
                    </tbody>
                </table>

                <!-- Buttons -->
                <div class="d-flex justify-content-end mt-3">
                    <button class="btn tertiary" @click="closeModal">Close</button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapActions } from 'vuex'

import Modal from './Modal'

export default {
    data() {
        return {
            tableData: {
                titles: [
                    {
                        title: 'Price Type per Group',
                        width: '25%'
                    },
                    {
                        title: 'Description',
                        width: '50%'
                    },
                    {
                        title: 'Channel Compatibility',
                        width: '25%'
                    }
                ],
                rows: [
                    {
                        priceType: 'Price per Person',
                        description: 'Each person pays this amount individually, but the price depends on the number of peolple',
                        channelCompatibility: 'Not supported by Get Your Guide and Viator'
                    },
                    {
                        priceType: 'Price per Group',
                        description: 'The group pays this amount regardless of the number of people',
                        channelCompatibility: 'Not supported by Get Your Guide and Viator'
                    },
                    {
                        priceType: 'Price per Category Tier',
                        description: 'Each person pays this amount individually, but the price depends on the number of people per category',
                        channelCompatibility: 'Not supported by Viator'
                    }
                ]
            }
        }
    },
    async mounted() {
		this.$nextTick(() => {
			this.eventHub.$on("closeTargetModal", () => {
			    this.closeModal();
			});
		});
	},
	destroyed() {
		this.eventHub.$off('closeTargetModal');
	},
    methods: {
        ...mapActions([
            'closeModal',
        ])
    },
    components: {
        Modal,
    }
}
</script>

<style lang="scss" scoped>
    .table {
        thead {
            tr th {
                color: #4b536b
            }
        }

        tbody {
            tr {
                cursor: default;
            }
    
            td {
                border-top: none
            }
    
            tr:hover {
                background-color: #fff;
                border: none;
                transform: none;
                cursor: default;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// PerGroupLearnMore.vue?6342cb6d